import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "ml-auto" }

import { computed, reactive, toRaw } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { useCommonStore } from '@/stores/CommonStore';
  import { useSitesStore } from '@/stores/SitesStore';
  import { useBuilderStore } from '@/stores/BuilderStore';
  import RequestTemplate from '@/factories/RequestTemplate';
  import Notification from '@/helpers/Notification';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

  const commonStore = useCommonStore();
  const sitesStore = useSitesStore();
  const builderStore = useBuilderStore();
  const router = useRouter();
  const route = useRoute();

  const state = reactive({ disabled: false });

  const creatureSite = computed(() => sitesStore.getCreature);
  const fieldsData = computed(() => builderStore.getFieldsData);
  const templateData = computed(() => builderStore.getTemplateData);

  const saveExit = () => {
    state.disabled = true;
    if (route.name === 'sites/create') {
      let data = toRaw(creatureSite.value);

      if (data)
        sitesStore
          .storeSiteData(data)
          .then(() => {
            router.push({ name: 'sites' });
            state.disabled = false;
          })
          .catch((error) => {
            const errors = Object.values(error.response.data.errors).flat(
              Infinity
            ) as any[];
            const str = errors.reduce(
              (a, b) => `${a} ${b} <br /> ${error}`,
              ''
            );

            Notification('Error here', str, 'error');
            state.disabled = false;
          });
    } else if (
      route.name === 'template/builder' ||
      route.name === 'template/create'
    ) {
      let arr = JSON.parse(JSON.stringify(fieldsData.value));
      let result = RequestTemplate.create(arr);

      builderStore
        .storeTemplateData({
          name: templateData.value.name,
          reference_name: templateData.value.reference_name,
          description: templateData.value.description,
          is_global: templateData.value.is_global,
          field_group_templates: result,
        })
        .then((data) => {
          if (data !== undefined) {
            router.push({ name: 'templates' });
          }
          state.disabled = false;
        });
    }
  };

  const exit = () => {
    router.push({ name: 'home' });
  };

  const setMediaLibraryDrawer = (value: boolean) => {
    commonStore.setMediaLibraryDrawer(value);
  };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setMediaLibraryDrawer(true))),
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Media Library ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_el_button, {
          onClick: saveExit,
          plain: "",
          disabled: state.disabled
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Save + Exit ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_el_button, {
          onClick: exit,
          plain: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Exit")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})